// import { create } from "@mui/material/styles/createTransitions";
import { createSlice } from "@reduxjs/toolkit";
import { Navigate } from "react-router-dom";
// import { actions } from "react-table";
//------sidebar---
const SidebarSlice = createSlice({
  name: "sidebar",
  initialState: {
    SidebarActive: true,
    plantid: "",
    projectid: "",
    projectwbsid: "",
    usereditid: "",
    forgotOtp: "",
  },
  reducers: {
    getsidebarActions: (state, actions) => {
      state.SidebarActive = actions.payload;
    },
    plantid: (state, actions) => {
      state.plantid = actions.payload;
    },
    projectid: (state, actions) => {
      state.projectid = actions.payload;
    },
    projectwbsid: (state, actions) => {
      state.projectwbsid = actions.payload;
    },
    usereditid: (state, actions) => {
      state.usereditid = actions.payload;
    },
    forgotOtp: (state, actions) => {
      state.forgotOtp = actions.payload;
    },
  },
});
// ------LoginSlice-------
const usersSlice = createSlice({
  name: "LoginData",
  initialState: {
    UserData: [],
    error: "",
  },
  reducers: {
    getUserAction: (state, payload) => {
      state.error = "";
      state.UserData = [];
    },
    getUserSuccessAction: (state, action) => {
      state.UserData = action.payload;
    },
    getUserErrorAction: (state, action) => {
      state.error = action.payload;
    },
  },
});
// ------ForgotOtpLoginSlice-------
const usersForgotSlice = createSlice({
  name: "ForgotOtpLoginData",
  initialState: {
    error: "",
  },
  reducers: {
    getForgotUserAction: (state, payload) => {
      state.error = "";
      state.UserData = [];
    },
    getForgotUserSuccessAction: (state, action) => {
      state.UserData = action.payload;
    },
    getForgotUserErrorAction: (state, action) => {
      state.error = action.payload;
    },
  },
});
// ------ForgotVerifyOtpLoginSlice-------
const usersVerifyOtpSlice = createSlice({
  name: "VerifyOtpLoginData",
  initialState: {
    error: "",
  },
  reducers: {
    getVerifyOtpUserAction: (state, payload) => {
      state.error = "";
      state.UserData = [];
    },
    getVerifyOtpUserSuccessAction: (state, action) => {
      state.UserData = action.payload;
    },
    getVerifyOtpUserErrorAction: (state, action) => {
      state.error = action.payload;
    },
  },
});
const usersResetPasswordSlice = createSlice({
  name: "ResetPasswordLoginData",
  initialState: {
    error: "",
  },
  reducers: {
    getResetPasswordUserAction: (state, payload) => {
      state.error = "";
      state.UserData = [];
    },
    getResetPasswordUserSuccessAction: (state, action) => {
      state.UserData = action.payload;
    },
    getresetPasswordErrorUserAction: (state, action) => {
      state.error = action.payload;
    },
  },
});

const plantListRetrieveSlice = createSlice({
  name: "plantListRetrieve",
  initialState: {
    plantListRetrieve: [],
    Error: "",
  },
  reducers: {
    setplantListRetrieveActions: (state, actions) => {
      state.plantListRetrieve = [];
      state.Error = "";
    },
    SetPlantListRetrieveSuccessResponse: (state, actions) => {
      state.plantListRetrieve = actions.payload;
    },
    SetPlantListRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
const clientListRetrieveSlice = createSlice({
  name: "clientListRetrieve",
  initialState: {
    clientListRetrieve: [],
    Error: "",
  },
  reducers: {
    setClientListRetrieveActions: (state, actions) => {
      state.clientListRetrieve = [];
      state.Error = "";
    },
    SetClientListRetrieveSuccessResponse: (state, actions) => {
      state.clientListRetrieve = actions.payload;
    },
    SetClientListRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const fileListRetrieveSlice = createSlice({
  name: "fileListRetrieve",
  initialState: {
    fileListRetrieve: [],
    fileListRetrieveproject: [],
    fileListRetrieveprojectwbs: [],
    plantemails: [],
    fileRetriveList: [],
    Error: "",
  },
  reducers: {
    setFileListRetrieveActions: (state, actions) => {
      state.fileListRetrieve = [];
      state.fileListRetrieveproject = [];
      state.fileListRetrieveprojectwbs = [];
      state.Error = "";
    },
    SetplantRetrieveSuccessResponse: (state, actions) => {
      state.plantemails = actions.payload;
    },
    SetFileListRetrieveSuccessResponse: (state, actions) => {
      state.fileListRetrieve = actions.payload;
    },
    SetFileListRetrieveprojectSuccessResponse: (state, actions) => {
      state.fileListRetrieveproject = actions.payload;
    },
    SetFileListRetrieveprojectwbsSuccessResponse: (state, actions) => {
      state.fileListRetrieveprojectwbs = actions.payload;
    },
    setFileRetriveList: (state, actions) => {
      state.fileRetriveList = actions.payload;
    },

    SetFileListUpdateSuccessResponse: (state, actions) => {
      state.fileListRetrieve = actions.payload;
    },
    SetFileListUpdateprojectSuccessResponse: (state, actions) => {
      state.fileListRetrieveproject = actions.payload;
    },
    SetFileListUpdateprojectwbsSuccessResponse: (state, actions) => {
      state.fileListRetrieveprojectwbs = actions.payload;
    },

    SetFileListRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
const createPlantSlice = createSlice({
  name: "createPlant",
  initialState: {
    createPlant: [],
    Error: "",
  },
  reducers: {
    CreatePlantActions: (state, actions) => {
      state.createPlant = [];
      state.Error = "";
    },
    CreatePlantUpdateResponse: (state, actions) => {
      state.createPlant = [];
      state.Error = "";
    },
    CreatePlantSuccessResponse: (state, actions) => {
      state.createPlant = actions.payload;
    },
    CreatePlantRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
const createProjectSlice = createSlice({
  name: "createProject",
  initialState: {
    createProject: [],
    Error: "",
  },
  reducers: {
    CreateProjectActions: (state, actions) => {
      state.createProject = [];
      state.Error = "";
    },
    CreateProjectSuccessResponse: (state, actions) => {
      state.createProject = actions.payload;
    },
    CreateProjectRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
    CreateProjectUpdateResponse: (state, actions) => {
      state.createProject = [];
    },
  },
});
const fetchProjectWbsSlice = createSlice({
  name: "fetchProjectWbs",
  initialState: {
    ProjectWbs: [],
    Error: "",
  },
  reducers: {
    FetchProjectWbsActions: (state, actions) => {
      state.ProjectWbs = [];
      state.Error = "";
    },
    FetchProjectWbsSuccessResponse: (state, actions) => {
      state.ProjectWbs = actions.payload;
    },
    FetchProjectWbsError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
const createProjectWbsSlice = createSlice({
  name: "createProjectWbs",
  initialState: {
    createProjectWbs: [],
    Error: "",
  },
  reducers: {
    CreateProjectWbsActions: (state, actions) => {
      state.createProjectWbs = [];
      state.Error = "";
    },
    CreateProjectWbsSuccessResponse: (state, actions) => {
      state.createProjectWbs = actions.payload;
    },
    CreateProjectWbsError: (state, actions) => {
      state.Error = actions.payload;
    },
    CreateProjectWbsUpdateActions: (state, actions) => {
      state.createProjectWbs = [];
      state.Error = "";
    },
  },
});
const updateProjectWbsSlice = createSlice({
  name: "updateProjectWbs",
  initialState: {
    updateProjectWbsData: [],
    Error: "",
  },
  reducers: {
    UpdateProjectWbsActions: (state, actions) => {
      state.updateProjectWbsData = [];
      state.Error = "";
    },
    UpdateProjectWbsSuccessResponse: (state, actions) => {
      state.updateProjectWbsData = actions.payload;
    },
    UpdateProjectWbsError: (state, actions) => {
      state.Error = actions.payload;
    },
    UpdateProjectWbsUpdateActions: (state, actions) => {
      state.updateProjectWbsData = [];
      state.Error = "";
    },
  },
});
const updateProjectSlice = createSlice({
  name: "updateProject",
  initialState: {
    updateProjectData: [],
    Error: "",
  },
  reducers: {
    UpdateProjectActions: (state, actions) => {
      state.updateProjectData = [];
      state.Error = "";
    },
    UpdateProjectSuccessResponse: (state, actions) => {
      state.updateProjectData = actions.payload;
    },
    UpdateProjectError: (state, actions) => {
      state.Error = actions.payload;
    },
    UpdateProjectupdateResponse: (state, actions) => {
      state.updateProjectData = [];
    },
  },
});
const updatePlantSlice = createSlice({
  name: "updatePlant",
  initialState: {
    updatePlantData: [],
    Error: "",
  },
  reducers: {
    UpdatePlantActions: (state, actions) => {
      state.updatePlantData = [];
      state.Error = "";
    },
    UpdatePlantSuccessResponse: (state, actions) => {
      state.updatePlantData = actions.payload;
    },
    UpdatePlantError: (state, actions) => {
      state.Error = actions.payload;
    },
    UpdatePlantScheduleResponse: (state, actions) => {
      state.updatePlantData = [];
      state.Error = "";
    },
  },
});
const createScheduleSlice = createSlice({
  name: "createSchedule",
  initialState: {
    createScheduleData: [],
    Error: "",
  },
  reducers: {
    CreateScheduleActions: (state, actions) => {
      state.createScheduleData = [];
      state.Error = "";
    },
    UpdateScheduleResponse: (state, actions) => {
      state.createScheduleData = [];
      state.Error = "";
    },
    CreateScheduleSuccessResponse: (state, actions) => {
      state.createScheduleData = actions.payload;
    },
    CreateScheduleError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const RetrieveInvoiceSlice = createSlice({
  name: "retrieveinvoice",
  initialState: {
    RetrieveInvoiceData: [],
    Error: "",
  },
  reducers: {
    RetrieveInvoiceActions: (state, actions) => {
      state.RetrieveInvoiceData = [];
      state.Error = "";
    },
    RetrieveNewInvoiceActions: (state, actions) => {
      state.RetrievenewInvoiceData = [];
      state.Error = "";
    },
    RetrieveInvoiceUpdateScheduleResponse: (state, actions) => {
      state.RetrieveInvoiceData = [];
      state.Error = "";
    },
    RetrieveInvoiceSuccessResponse: (state, actions) => {
      state.RetrieveInvoiceData = actions.payload;
    },
    RetrieveInvoiceError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const graphListRetrieveSlice = createSlice({
  name: "graphListRetrieve",
  initialState: {
    graphListRetrieve: [],
    Error: "",
  },
  reducers: {
    setGraphListRetrieveActions: (state, actions) => {
      state.graphListRetrieve = [];
      state.Error = "";
    },
    SetGraphListRetrieveSuccessResponse: (state, actions) => {
      state.graphListRetrieve = actions.payload;
    },
    SetGraphListRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const RetrieveScheduledInvoiceSlice = createSlice({
  name: "retrievescheduledinvoice",
  initialState: {
    RetrieveScheduledInvoiceData: [],
    Error: "",
  },
  reducers: {
    RetrieveScheduledInvoiceActions: (state, actions) => {
      state.RetrieveScheduledInvoiceData = [];
      state.Error = "";
    },
    RetrieveScheduledInvoiceUpdateScheduleResponse: (state, actions) => {
      state.RetrieveScheduledInvoiceData = [];
      state.Error = "";
    },
    RetrieveScheduledInvoiceSuccessResponse: (state, actions) => {
      state.RetrieveScheduledInvoiceData = actions.payload;
    },
    RetrieveScheduledInvoiceError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const plantListgetdropSlice = createSlice({
  name: "plantListgetdrop",
  initialState: {
    plantListgetdrop: [],
    Error: "",
  },
  reducers: {
    setplantListgetdropActions: (state, actions) => {
      state.plantListgetdrop = [];
      state.Error = "";
    },
    SetPlantListgetdropSuccessResponse: (state, actions) => {
      state.plantListgetdrop = actions.payload;
    },
    SetPlantListgetdropError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const projectListgetdropSlice = createSlice({
  name: "projectListgetdrop",
  initialState: {
    projectListgetdrop: [],
    Error: "",
  },
  reducers: {
    setprojectListgetdropActions: (state, actions) => {
      state.projectListgetdrop = [];
      state.Error = "";
    },
    SetprojectListgetdropSuccessResponse: (state, actions) => {
      state.projectListgetdrop = actions.payload;
    },
    SetprojectListgetdropError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const projectwbsListgetdropSlice = createSlice({
  name: "projectwbsListgetdrop",
  initialState: {
    projectwbsListgetdrop: [],
    Error: "",
  },
  reducers: {
    setprojectwbsListgetdropActions: (state, actions) => {
      state.projectwbsListgetdrop = [];
      state.Error = "";
    },
    SetprojectwbsListgetdropSuccessResponse: (state, actions) => {
      state.projectwbsListgetdrop = actions.payload;
    },
    SetprojectwbsListgetdropError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const UserGetSlice = createSlice({
  name: "UserGet",
  initialState: {
    UserGet: [],
    Error: "",
  },
  reducers: {
    setUserGetActions: (state, actions) => {
      state.UserGet = [];
      state.Error = "";
    },
    SetUserGetSuccessResponse: (state, actions) => {
      state.UserGet = actions.payload;
    },
    SetUserGetError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const UserPostSlice = createSlice({
  name: "UserPost",
  initialState: {
    UserPost: [],
    Error: "",
  },
  reducers: {
    setUserPostActions: (state, actions) => {
      state.UserPost = [];
      state.Error = "";
    },
    SetUserPostSuccessResponse: (state, actions) => {
      state.UserPost = actions.payload;
    },
    SetUserPostUpdateResponse: (state, actions) => {
      state.UserPost = actions.payload;
    },

    SetUserPostError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const UserPutSlice = createSlice({
  name: "UserPut",
  initialState: {
    UserPut: [],
    Error: "",
  },
  reducers: {
    setUserPutActions: (state, actions) => {
      state.UserPut = [];
      state.Error = "";
    },
    SetUserPutSuccessResponse: (state, actions) => {
      state.UserPut = actions.payload;
    },
    SetUserPutUpdateResponse: (state, actions) => {
      state.UserPut = actions.payload;
    },

    SetUserPutError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const CommonPostSlice = createSlice({
  name: "CommonPost",
  initialState: {
    CommonPost: [],
    Error: "",
  },
  reducers: {
    setCommonPostActions: (state, actions) => {
      state.CommonPost = [];
      state.Error = "";
    },
    SetCommonPostSuccessResponse: (state, actions) => {
      state.CommonPost = actions.payload;
    },
    SetCommonPostUpdateResponse: (state, actions) => {
      state.CommonPost = actions.payload;
    },

    SetCommonPostError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

export const {
  RetrieveScheduledInvoiceActions,
  RetrieveScheduledInvoiceUpdateScheduleResponse,
  RetrieveScheduledInvoiceSuccessResponse,
  RetrieveScheduledInvoiceError,
} = RetrieveScheduledInvoiceSlice.actions;
export const {
  RetrieveInvoiceActions,
  RetrieveInvoiceUpdateScheduleResponse,
  RetrieveInvoiceSuccessResponse,
  RetrieveInvoiceError,
  RetrieveNewInvoiceActions,
} = RetrieveInvoiceSlice.actions;

//-----------Actions------------
// <-------Create Schedule WBS--------->
export const {
  CreateScheduleActions,
  UpdateScheduleResponse,
  CreateScheduleSuccessResponse,
  CreateScheduleError,
} = createScheduleSlice.actions;
// <-------Create Project WBS--------->
export const {
  UpdateProjectWbsActions,
  UpdateProjectWbsSuccessResponse,
  UpdateProjectWbsError,
  UpdateProjectWbsUpdateActions,
} = updateProjectWbsSlice.actions;
// <-------Create Project WBS--------->
export const {
  UpdateProjectActions,
  UpdateProjectSuccessResponse,
  UpdateProjectError,
  UpdateProjectupdateResponse,
} = updateProjectSlice.actions;
// <-------Create Project WBS--------->
export const {
  UpdatePlantActions,
  UpdatePlantSuccessResponse,
  UpdatePlantError,
  UpdatePlantScheduleResponse,
} = updatePlantSlice.actions;

// <-------Create Project WBS--------->
export const {
  CreateProjectWbsActions,
  CreateProjectWbsSuccessResponse,
  CreateProjectWbsError,
  CreateProjectWbsUpdateActions,
} = createProjectWbsSlice.actions;

// <-------Fetch Project WBS--------->
export const {
  FetchProjectWbsActions,
  FetchProjectWbsSuccessResponse,
  FetchProjectWbsError,
} = fetchProjectWbsSlice.actions;
// <-------create Project--------->
export const {
  CreateProjectActions,
  CreateProjectSuccessResponse,
  CreateProjectRetrieveError,
  CreateProjectUpdateResponse,
} = createProjectSlice.actions;
// <-------Create plants--------->
export const {
  CreatePlantActions,
  CreatePlantSuccessResponse,
  CreatePlantRetrieveError,
  CreatePlantUpdateResponse,
} = createPlantSlice.actions;

// <-------plants--------->
export const { getUserAction, getUserSuccessAction, getUserErrorAction } =
  usersSlice.actions;
// <-------Login------------>
export const {
  getForgotUserAction,
  getForgotUserSuccessAction,
  getForgotUserErrorAction,
} = usersForgotSlice.actions;
// <-------set otp------------>

export const {
  getVerifyOtpUserAction,
  getVerifyOtpUserSuccessAction,
  getVerifyOtpUserErrorAction,
} = usersVerifyOtpSlice.actions;
// <-------Verify Otp------------>

export const {
  getResetPasswordUserAction,
  getResetPasswordUserSuccessAction,
  getResetPasswordUserErrorAction,
} = usersResetPasswordSlice.actions;
// <-------Reset Password------------>
export const {
  getsidebarActions,
  plantid,
  projectid,
  projectwbsid,
  usereditid,
  forgotOtp,
} = SidebarSlice.actions;
// <-------Client--------->
export const {
  setClientListRetrieveActions,
  SetClientListRetrieveSuccessResponse,
  SetClientListRetrieveError,
} = clientListRetrieveSlice.actions;
export const {
  setplantListRetrieveActions,
  SetPlantListRetrieveSuccessResponse,
  SetPlantListRetrieveError,
} = plantListRetrieveSlice.actions;
export const {
  // setFileListUpdateActions,
  setFileListRetrieveActions,
  SetplantRetrieveSuccessResponse,
  SetFileListRetrieveSuccessResponse,
  SetFileListRetrieveprojectSuccessResponse,
  SetFileListRetrieveprojectwbsSuccessResponse,
  SetFileListUpdateSuccessResponse,
  setFileRetriveList,
  SetFileListUpdateprojectSuccessResponse,
  SetFileListUpdateprojectwbsSuccessResponse,
  SetFileListRetrieveError,
} = fileListRetrieveSlice.actions;

export const {
  setplantListgetdropActions,
  SetPlantListgetdropSuccessResponse,
  SetPlantListgetdropError,
} = plantListgetdropSlice.actions;

export const {
  setprojectListgetdropActions,
  SetprojectListgetdropSuccessResponse,
  SetprojectListgetdropError,
} = projectListgetdropSlice.actions;

export const {
  setprojectwbsListgetdropActions,
  SetprojectwbsListgetdropSuccessResponse,
  SetprojectwbsListgetdropError,
} = projectwbsListgetdropSlice.actions;

export const {
  setGraphListRetrieveActions,
  SetGraphListRetrieveSuccessResponse,
  SetGraphListRetrieveError,
} = graphListRetrieveSlice.actions;

export const { setUserGetActions, SetUserGetSuccessResponse, SetUserGetError } =
  UserGetSlice.actions;

export const {
  setUserPostActions,
  SetUserPostSuccessResponse,
  SetUserPostUpdateResponse,
  SetUserPostError,
} = UserPostSlice.actions;

export const {
  setUserPutActions,
  SetUserPutSuccessResponse,
  SetUserPutUpdateResponse,
  SetUserPutError,
} = UserPutSlice.actions;

export const {
  setCommonPostActions,
  SetCommonPostSuccessResponse,
  SetCommonPostUpdateResponse,
  SetCommonPostError,
} = CommonPostSlice.actions;
//------- ---REDUCERS----------------
// export default {
//   SideBarActive: SidebarSlice.reducer,
//   userReducer: usersSlice.reducer,
//   fetchPlantReducer: plantListRetrieveSlice.reducer,
//   fetchClientReducer: clientListRetrieveSlice.reducer,
//   fetchFileReducer: fileListRetrieveSlice.reducer,
// };
const reducers = {
  SideBarActive: SidebarSlice.reducer,
  userReducer: usersSlice.reducer,
  userForgotReducer: usersForgotSlice.reducer,
  userVerifyOtpReducer: usersVerifyOtpSlice.reducer,
  resetPasswordReducer: usersResetPasswordSlice.reducer,
  fetchPlantReducer: plantListRetrieveSlice.reducer,
  fetchClientReducer: clientListRetrieveSlice.reducer,
  fetchFileReducer: fileListRetrieveSlice.reducer,
  createPlantReducer: createPlantSlice.reducer,
  createProjectReducer: createProjectSlice.reducer,
  fetchProjectWbsReducer: fetchProjectWbsSlice.reducer,
  createProjectWbsReducer: createProjectWbsSlice.reducer,
  updateProjectWbsReducer: updateProjectWbsSlice.reducer,
  updatePlantReducer: updatePlantSlice.reducer,
  updateProjectReducer: updateProjectSlice.reducer,
  createScheduleReducer: createScheduleSlice.reducer,
  RetrieveInvoiceReducer: RetrieveInvoiceSlice.reducer,
  RetrieveScheduledInvoiceReducer: RetrieveScheduledInvoiceSlice.reducer,
  plantListgetdropReducer: plantListgetdropSlice.reducer,
  projectListgetdropReducer: projectListgetdropSlice.reducer,
  projectwbsListgetdropReducer: projectwbsListgetdropSlice.reducer,
  UserGetReduer: UserGetSlice.reducer,
  UserPostReduer: UserPostSlice.reducer,
  UserPutReduer: UserPutSlice.reducer,
  CommonPostReduer: CommonPostSlice.reducer,
  graphListRetrieveReducer: graphListRetrieveSlice.reducer,
};

export default reducers;
